import { useMutation, useQueryClient } from '@tanstack/react-query';

import { IRestaurantsPayload, useRestaurantsService } from '@restworld/data-services';

import { useEmployerRestaurantDetailsQueryKey } from './use-employer-restuarant-details';

function useUpdateRestaurantMutation() {
  const queryClient = useQueryClient();
  const restaurantsService = useRestaurantsService();
  const restaurantDetailsQueryKey = useEmployerRestaurantDetailsQueryKey();

  return useMutation({
    mutationFn: ({
      restaurantId,
      restaurantPayload,
    }: {
      restaurantId: string;
      restaurantPayload: IRestaurantsPayload;
    }) =>
      restaurantsService.updateRestaurant({
        restaurantId,
        params: {
          ...restaurantPayload,
        },
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: restaurantDetailsQueryKey });
    },
  });
}

export default useUpdateRestaurantMutation;
